import { computePercentage, getSymbol } from '../../../helpers/functions';

import AssetTargetDetails from './PriceTargetListItem/AssetTargetDetails';
import { StrategyProgressBar } from './ProgressBar/StrategyProgressBar';
import { ImageAndName } from './PriceTargetListItem/Utils';

import { IStrategyAsset } from '../../../types/model';
import { Currency } from '../../../types/common';
import { CustomNumber } from '../../CustomNumber/CustomNumber';
import { ProfitLoss } from '../../ProfitLoss';

const PriceTargetsListItemSingle = ({
  assetData,
  currency,
  setAssetTargetDetails,
}: {
  assetData: IStrategyAsset;
  currency: Currency['code'];
  setAssetTargetDetails: React.Dispatch<
    React.SetStateAction<JSX.Element | undefined>
  >;
}) => {
  const { asset, entryPrice, strategyAssetTargets } = assetData;
  const { history, name, logo, symbol, type } = asset;
  const lastPrice = history[0]?.[currency.toLocaleLowerCase()];

  const percentage = computePercentage(entryPrice!, lastPrice, 100);
  return (
    <div
      className="flex flex-col px-3 py-4 border-b border-grey-10 dark:border-grey-70"
      onClick={() =>
        setAssetTargetDetails(
          <AssetTargetDetails
            assetData={assetData as IStrategyAsset}
            goBack={() => setAssetTargetDetails(undefined)}
            currency={currency}
          />
        )
      }
    >
      <ImageAndName
        className="mb-3"
        name={name}
        logo={logo}
        symbol={
          type && ['CRYPTO', 'STOCK'].includes(type) ? symbol : asset.name
        }
        type={type!}
      />

      <div className="grid grid-cols-2">
        <div>
          <div className="text-sm text-grey-50">Entry price</div>
          <CustomNumber
            className="font-medium"
            value={entryPrice}
            suffix={getSymbol(currency)}
          />
        </div>
        <div>
          <div className="text-sm text-grey-50">Last price</div>
          <CustomNumber
            className="font-medium"
            value={lastPrice}
            suffix={getSymbol(currency)}
          />
          <ProfitLoss
            valueClassName="w-32"
            isRow
            percentage={percentage}
            performancePosition="value"
            prefixPercentage="("
            suffixPercentage="%)"
            symbol={getSymbol(currency)}
            value={lastPrice - entryPrice}
          />
        </div>
      </div>

      <div className="my-4">
        <div className="text-sm text-grey-50 mb-2">Strategy progress</div>

        <StrategyProgressBar
          currency={currency}
          entryPrice={entryPrice}
          lastPrice={lastPrice}
          markers={strategyAssetTargets!.items}
        />
      </div>
    </div>
  );
};

export default PriceTargetsListItemSingle;
